import dashboardIcon from "assets/icons/dashboard.svg";
import reportIcon from "assets/icons/reports.svg";
import projectIcon from "assets/icons/projects.svg";
import userManageIcon from "assets/icons/usersmanage.svg";
import aboutIcon from "assets/icons/aboutIcon.svg";
import settingsIcon from "assets/icons/settings.svg";
import activityIcon from "assets/icons/activities.svg";
import attendanceIcon from "assets/icons/attendance.svg";
import termsIcon from "assets/icons/terms.svg";
import productivityInActive from "assets/icons/productivityInActive.svg";
// active icons
import dashboardActiveIcon from "assets/icons/dashboardActiveIcon.svg";
import reportActiveIcon from "assets/icons/reportActiveIcon.svg";
import projectActiveIcon from "assets/icons/projectActiveIcon.svg";
import userManageActiveIcon from "assets/icons/userActiveIcon.svg";
import aboutActiveIcon from "assets/icons/aboutActiveIcon.svg";
import settingsActiveIcon from "assets/icons/settingsActiveIcon.svg";
import masterpageicon from "assets/icons/masterpageicon.svg";
import masterquantity from "assets/icons/masterquantity.svg";
import activityActiveIcon from "assets/icons/activityActiveIcon.svg";
import attendanceActiveIcon from "assets/icons/attendanceActiveIcon.svg";
import termsActiveIcon from "assets/icons/termsActiveIcon.svg";
import productivityActiveIcon from "assets/icons/productivityActive.svg";

export const menuItems = [
  {
    module: "Dashboard",
    icon: dashboardIcon,
    activeIcon: dashboardActiveIcon,
    link: "/dashboard",
    value: 1,
  },
  {
    module: "Projects",
    icon: projectIcon,
    activeIcon: projectActiveIcon,
    link: "/projects",
    value: 1,
  },
  {
    module: "User Management",
    icon: userManageIcon,
    activeIcon: userManageActiveIcon,
    link: "/users",
    value: 1,
  },
  {
    module: "Activities",
    icon: activityIcon,
    activeIcon: activityActiveIcon,
    link: "/activities",
    value: 1,
  },
  {
    module: "Reports",
    icon: reportIcon,
    activeIcon: reportActiveIcon,
    link: "/reports",
    value: 1,
  },
  {
    module: "Attendance Report",
    icon: attendanceIcon,
    activeIcon: attendanceActiveIcon,
    link: "/attendanceReports",
    value: 1,
  },
  {
    module: "Productivity",
    icon: productivityInActive,
    activeIcon: productivityActiveIcon,
    link: "/productivity",
    value: 1,
  },
  {
    module: "Master",
    icon: masterpageicon,
    activeIcon: masterpageicon,
    link: "/master/:mode",
    value: 1,
  },
  {
    module: "Master Quantity",
    icon: masterquantity,
    activeIcon: masterquantity,
    link: "/MasterQuantity",
    value: 1,
  },
  {
    module: "About",
    icon: aboutIcon,
    activeIcon: aboutActiveIcon,
    link: "/about",
    value: 1,
  },
  {
    module: "Terms & Policies",
    icon: termsIcon,
    activeIcon: termsActiveIcon,
    link: "/termsPolicies",
    value: 1,
  },

  {
    module: "Settings",
    icon: settingsIcon,
    activeIcon: settingsActiveIcon,
    link: "/settings",
    value: 1,
  },
];
export const menuItemsManager = [
  {
    module: "Dashboard",
    icon: dashboardIcon,
    activeIcon: dashboardActiveIcon,
    link: "/dashboard",
    value: 1,
  },
  {
    module: "Projects",
    icon: projectIcon,
    activeIcon: projectActiveIcon,
    link: "/projects",
    value: 1,
  },
  {
    module: "User Management",
    icon: userManageIcon,
    activeIcon: userManageActiveIcon,
    link: "/users",
    value: 1,
  },
  {
    module: "Reports",
    icon: reportIcon,
    activeIcon: reportActiveIcon,
    link: "/reports",
    value: 1,
  },

  {
    module: "Attendance Report",
    icon: attendanceIcon,
    activeIcon: attendanceActiveIcon,
    link: "/attendanceReports",
    value: 1,
  },
  {
    module: "Productivity",
    icon: productivityInActive,
    activeIcon: productivityActiveIcon,
    link: "/productivity",
    value: 1,
  },
  {
    module: "Master",
    icon: masterpageicon,
    activeIcon: masterpageicon,
    link: "/master/:mode",
    value: 1,
  },
  {
    module: "Master Quantity",
    icon: masterquantity,
    activeIcon: masterquantity,
    link: "/MasterQuantity",
    value: 1,
  },
  {
    module: "About",
    icon: aboutIcon,
    activeIcon: aboutActiveIcon,
    link: "/about",
    value: 1,
  },
  {
    module: "Terms & Policies",
    icon: termsIcon,
    activeIcon: termsActiveIcon,
    link: "/termsPolicies",
    value: 1,
  },

  {
    module: "Settings",
    icon: settingsIcon,
    activeIcon: settingsActiveIcon,
    link: "/settings",
    value: 1,
  },
];

export const menuItemsCosting = [
  {
    module: "Dashboard",
    icon: dashboardIcon,
    activeIcon: dashboardActiveIcon,
    link: "/dashboard",
    value: 1,
  },
  {
    module: "Projects",
    icon: projectIcon,
    activeIcon: projectActiveIcon,
    link: "/projects",
    value: 1,
  },
  {
    module: "User Management",
    icon: userManageIcon,
    activeIcon: userManageActiveIcon,
    link: "/users",
    value: 1,
  },
  {
    module: "Activities",
    icon: activityIcon,
    activeIcon: activityActiveIcon,
    link: "/activities",
    value: 1,
  },
  {
    module: "Reports",
    icon: reportIcon,
    activeIcon: reportActiveIcon,
    link: "/reports",
    value: 1,
  },

  {
    module: "Attendance Report",
    icon: attendanceIcon,
    activeIcon: attendanceActiveIcon,
    link: "/attendanceReports",
    value: 1,
  },
  {
    module: "Productivity",
    icon: productivityInActive,
    activeIcon: productivityActiveIcon,
    link: "/productivity",
    value: 1,
  },
  {
    module: "Master",
    icon: masterpageicon,
    activeIcon: masterpageicon,
    link: "/master/:mode",
    value: 1,
  },
  {
    module: "Master Quantity",
    icon: masterquantity,
    activeIcon: masterquantity,
    link: "/MasterQuantity",
    value: 1,
  },
  {
    module: "About",
    icon: aboutIcon,
    activeIcon: aboutActiveIcon,
    link: "/about",
    value: 1,
  },
  {
    module: "Terms & Policies",
    icon: termsIcon,
    activeIcon: termsActiveIcon,
    link: "/termsPolicies",
    value: 1,
  },

  {
    module: "Settings",
    icon: settingsIcon,
    activeIcon: settingsActiveIcon,
    link: "/settings",
    value: 1,
  },
];

export const UserHeaders = [
  { label: "S.No" },
  {
    label: "User Name",
    isSort: true,
    key: "employee_name",
    minWidth: 60,
  },
  {
    label: "Employee ID",
    isSort: true,
    key: "employee_code",
    minWidth: 60,
  },
  {
    label: "Department",
    isSort: true,
    key: "trade",
    minWidth: 60,
  },
  { label: "Role", isSort: true, key: "role", minWidth: 60 },
  {
    label: "Assigned Project",
    isSort: true,
    key: "style",
    minWidth: 60,
  },
  { label: "Status", isSort: true, key: "style", minWidth: 60 },
  { label: "Action", key: " ", isSort: true, minWidth: 60 },
];

export const projectActiveHeaders = [
  { label: "S.No", isSort: false, minWidth: 60 },
  {
    label: "Project Name",
    isSort: true,
    key: "project_name",
    minWidth: 60,
  },
  { label: "Region", isSort: true, key: "region", minWidth: 60 },
  {
    label: "Wing",
    isSort: true,
    key: "wings_count",
    minWidth: 60,
  },
  {
    label: "Floor No",
    isSort: true,
    key: "floors_count",
    minWidth: 60,
  },
  {
    label: "Unit No",
    isSort: true,
    key: "flats_count",
    minWidth: 60,
  },
  {
    label: "Work Location",
    isSort: true,
    key: "areas_count",
    minWidth: 60,
  },
  {
    label: "Total Units",
    key: "units",
    isSort: true,
    minWidth: 60,
  },
  { label: "Status", isSort: true, key: "style", minWidth: 60 },
  { label: "Action", key: " ", isSort: false, minWidth: 60 },
];
export const projectInActiveHeaders = [
  { label: "S.No", isSort: true, minWidth: 60 },
  {
    label: "Project Name",
    isSort: true,
    key: "project_name",
    minWidth: 60,
  },
  { label: "Region", isSort: true, key: "region", minWidth: 60 },
  {
    label: "Wing",
    isSort: true,
    key: "wings_count",
    minWidth: 60,
  },
  {
    label: "Floor No",
    isSort: true,
    key: "floors_count",
    minWidth: 60,
  },
  {
    label: "Unit No",
    isSort: true,
    key: "flats_count",
    minWidth: 60,
  },
  {
    label: "Work Location",
    isSort: true,
    key: "areas_count",
    minWidth: 60,
  },
  {
    label: "Total Units",
    isSort: true,
    key: "units",
    minWidth: 60,
  },
  { label: "Status", key: "style", minWidth: 60 },
  { label: "Action", key: " ", isSort: false, minWidth: 60 },
];
export const ActivityHeaders = [
  { label: "S.No", isSort: true, minWidth: 60 },
  {
    label: "Activity Name",
    isSort: true,
    key: "activity_name",
    minWidth: 60,
  },
  {
    label: "Sub Activity",
    isSort: false,
    key: "sub_activity_name",
    minWidth: 60,
  },
  { label: "Region", isSort: false, key: "region", minWidth: 60 },
  {
    label: "Trade",
    isSort: true,
    key: "activity_trade_name",
    minWidth: 60,
  },
  {
    label: "UOM",
    isSort: false,
    key: "unit_measurement",
    minWidth: 60,
  },
  { label: "Action", key: " ", isSort: false, minWidth: 60 },
];
export const reportHeaders = [
  { label: "S.No", isSort: false, minWidth: 60 },
  { label: "Date", isSort: true, key: "activity_date", minWidth: 60 },
  { label: "Foreman Name", isSort: true, key: "foreman_name", minWidth: 60 },
  {
    label: "Technician Name",
    isSort: true,
    key: "technician_name",
    minWidth: 60,
  },
  {
    label: "Technician Id",
    isSort: true,
    key: "technician_code",
    minWidth: 60,
  },
  { label: "Project Name", isSort: false, key: "project_name", minWidth: 160 },
  { label: "Trade", isSort: false, key: "activity_trade_name", minWidth: 60 },
  { label: "Wing", isSort: false, key: "activity_wings_name", minWidth: 60 },
  {
    label: "Floor Number",
    isSort: false,
    key: "activity_floor_name",
    minWidth: 60,
  },
  {
    label: "Flat Number",
    isSort: false,
    key: "activity_flat_name",
    minWidth: 60,
  },
  { label: "Unit", isSort: false, key: "unit_number", minWidth: 60 },
  { label: "Location", isSort: false, key: "location", minWidth: 60 },
  { label: "Activity", isSort: true, key: "activity_name", minWidth: 60 },
  {
    label: "Sub Activity",
    isSort: true,
    key: "sub_activity_name",
    minWidth: 60,
  },
  {
    label: "Executed Hours",
    isSort: false,
    key: "executed_hours",
    minWidth: 60,
  },
  {
    label: "Executed Quantity",
    isSort: false,
    key: "executed_quantity",
    minWidth: 60,
  },
  {
    label: "Approved Quantity",
    isSort: false,
    key: "accepted_quantity",
    minWidth: 60,
  },
  {
    label: "Approved Hours",
    isSort: false,
    key: "approved_hours",
    minWidth: 60,
  },
  { label: "Action", key: " ", isSort: false, minWidth: 60 },
];

export const dashboardHeaders = [
  { label: "S.No" },
  { label: "Date", isSort: true },
  { label: "Incharge Name", isSort: true, key: "orderReference" },
  { label: "Project Name", isSort: true, key: "customerName" },
  { label: "Place of Work", isSort: true, key: "season" },
  { label: "Trade", isSort: true },
  { label: "Activities", isSort: true },
  { label: "Sub Activity", isSort: true },
  { label: "Quantity", isSort: true },
  { label: "UOM", isSort: true },
  { label: "Remarks", isSort: true },
];
export const attendanceHeaders = [
  { label: "S.No", isSort: true, minWidth: 60 },
  {
    label: "Date",
    isSort: true,
    key: "punch_date",
    minWidth: 60,
  },
  {
    label: "Employee ID",
    isSort: true,
    key: "employee_id",
    minWidth: 60,
  },
  {
    label: "Name",
    isSort: true,
    key: "employee_name",
    minWidth: 60,
  },
  { label: "Role", isSort: true, minWidth: 60 },
  {
    label: "Project",
    isSort: false,
    key: "project_name",
    minWidth: 60,
  },
  {
    label: "Trade",
    isSort: false,
    key: "employee_trade_name",
    minWidth: 60,
  },
  {
    label: "In Time",
    isSort: false,
    key: "punch_in_time",
    minWidth: 60,
  },
  {
    label: "Out Time",
    isSort: false,
    key: "punch_out_time",
    minWidth: 60,
  },
  {
    label: "Executed Hours",
    isSort: false,
    key: "working_hours",
    minWidth: 60,
  },
];

export const productivityHeaders = [
  { label: "S.No", key: "sno", isSort: false, minWidth: 60 },
  { label: "Date", key: "activity_date", isSort: true, minWidth: 160 },
  { label: "Foreman Name", key: "foreman_name", isSort: true, minWidth: 160 },
  { label: "Foreman Id", key: "foreman_code", isSort: true, minWidth: 160 },
  {
    label: "Technician Name",
    key: "technician_name",
    isSort: true,
    minWidth: 160,
  },
  {
    label: "Technician Id",
    key: "technician_code",
    isSort: true,
    minWidth: 160,
  },
  { label: "Project Name", key: "project_name", isSort: true, minWidth: 160 },
  { label: "Grade", key: "technician_grade_name", isSort: true, minWidth: 160 },
  { label: "Wing", key: "activity_wings_name", isSort: true, minWidth: 160 },
  {
    label: "Floor No",
    key: "activity_floor_name",
    isSort: true,
    minWidth: 160,
  },
  { label: "Unit No", key: "activity_flat_name", isSort: true, minWidth: 160 },
  {
    label: "Work Location",
    key: "activity_area_name",
    isSort: true,
    minWidth: 160,
  },
  { label: "Trades", key: "activity_trade_name", isSort: true, minWidth: 160 },
  { label: "Activity", key: "activity_name", isSort: true, minWidth: 160 },
  {
    label: "Sub Activity",
    key: "sub_activity_name",
    isSort: true,
    minWidth: 160,
  },
  { label: "UOM", key: "unit_measurement", isSort: true, minWidth: 160 },
  {
    label: "Executed Hours",
    key: "executed_hours",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Executed Quantity",
    key: "executed_quantity",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Approved Quantity",
    key: "approved_quantity",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Approved Hours",
    key: "approved_hours",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Expected work to be done",
    key: "targeted_quantity",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Productivity for 8 hours",
    key: "productive_for_8_hours",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Targeted Quantity",
    key: "targeted_quantity",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Short fall in Quantity",
    key: "short_fall_in_quantity",
    isSort: false,
    minWidth: 160,
  },
  {
    label: "Productivity Percentage (%)",
    key: "performance_percentage",
    isSort: false,
    minWidth: 180,
  },
  {
    label: "Actual Achieved in Hours",
    key: "actual_achieved_in_hours",
    isSort: false,
    minWidth: 160,
  },
  { label: "Remarks", key: "remarks", isSort: false, minWidth: 160 },
  { label: "Action", key: " ", isSort: false, minWidth: 60 },
];

export const nonProductivityHeaders = [
  { label: "S.No", key: "sno", isSort: false, minWidth: 60 },
  { label: "Date", key: "activity_date", isSort: true, minWidth: 60 },
  { label: "Foreman Name", key: "foreman_name", isSort: true, minWidth: 60 },
  { label: "Foreman Id", key: "foreman_code", isSort: true, minWidth: 60 },
  { label: "Technician Name", key: "foreman_code", isSort: true, minWidth: 60 },
  {
    label: "Technician Id",
    key: "technician_code",
    isSort: true,
    minWidth: 60,
  },
  { label: "Project Name", key: "project_name", isSort: true, minWidth: 60 },
  { label: "Grade", key: "technician_grade_name", isSort: true, minWidth: 60 },
  { label: "Wing", key: "activity_wings_name", isSort: true, minWidth: 60 },
  { label: "Floor No", key: "activity_floor_name", isSort: true, minWidth: 60 },
  { label: "Unit No", key: "activity_flat_name", isSort: true, minWidth: 60 },
  {
    label: "Work Location",
    key: "activity_area_name",
    isSort: true,
    minWidth: 60,
  },
  { label: "Trade", key: "activity_trade_name", isSort: true, minWidth: 60 },
  { label: "Activity", key: "activity_name", isSort: true, minWidth: 60 },
  {
    label: "Sub Activity",
    key: "sub_activity_name",
    isSort: true,
    minWidth: 60,
  },
  { label: "UOM", key: "unit_measurement", isSort: true, minWidth: 60 },
  {
    label: "Executed Hours",
    key: "executed_hours",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Executed Quantity",
    key: "executed_quantity",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Approved Quantity",
    key: "approved_quantity",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Approved Hours",
    key: "approved_hours",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Expected work to be done",
    key: "targeted_quantity",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Productivity for 8 hours",
    key: "productive_for_8_hours",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Targeted Quantity",
    key: "targeted_quantity",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Short fall in Quantity",
    key: "short_fall_in_quantity",
    isSort: false,
    minWidth: 60,
  },
  {
    label: "Productivity Percentage (%)",
    key: "performance_percentage",
    isSort: false,
    minWidth: 180,
  },
  {
    label: "Actual Achieved in Hours",
    key: "actual_achieved_in_hours",
    isSort: false,
    minWidth: 60,
  },
  { label: "Remarks", key: "remarks", isSort: false, minWidth: 60 },
  { label: "Action", show: true, key: " ", isSort: false, minWidth: 60 },
];
